<script>
  import RecuperarSenha from './partials/RecuperarSenha'
  import FormularioContato from '../../pessoal/components/Contato'

  import * as authService from '../../../services/authService'

  import bus from '@utils/bus'
  import {get} from '@utils/storage'
  import helpers from '@mixins/helper'
  import {mapGetters, mapActions} from 'vuex'

  import {required} from 'vuelidate/lib/validators'
  import {clone} from 'lodash'
  import moment from 'moment'

  export default {
    mixins: [helpers],
    components: {RecuperarSenha, FormularioContato},
    data () {
      return {
        botaoClicado: false,
        mostrarRecuperacaoSenha: false,
        mostrarModalContato: false,
        mostrarModalInicial: false,
        form: {
          login: '',
          password: ''
        },
        turno: 'manha'
      }
    },
    validations: {
      form: {
        login: {required},
        password: {required}
      }
    },
    computed: {
      ...mapGetters(['currentUser'])
    },
    beforeMount () {
      let horaAtual = moment().format('HH:mm')
      if (horaAtual >= '07:00' && horaAtual <= '18:00') {
        this.turno = 'manha'
      } else {
        this.turno = 'noite'
      }
    },
    mounted () {
      if (this.$route.name !== 'recuperacao-de-acesso') {
        // this.mostrarModalInicial = !window.localStorage.getItem('introjs') || true
        this.mostrarModalInicial = false
        if (this.mostrarModalInicial) {
          bus.$emit('hide-loader')
        }
      } else {
        this.mostrarRecuperacaoSenha = true
      }
      this.iniciarLogin(100)
    },
    watch: {
      mostrarModalInicial: function (newValue, oldValue) {
        if (!newValue && oldValue) {
          this.$refs.login.focus()
        }
      },
      mostrarRecuperacaoSenha: function (newValue, oldValue) {
        if (!newValue && oldValue) {
          this.iniciarLogin(100)
        }
      }
    },
    methods: {
      ...mapActions(['login']),
      iniciarLogin (timeout) {
        timeout = timeout || 800
        setTimeout(() => {
          if (this.$refs.login) {
            this.$refs.login.focus()
          }
          bus.$emit('hide-loader')
        }, timeout)
      },
      async onLogin () {
        bus.$emit('show-loader', {message: 'Estamos verificando seus dados'})
        this.botaoClicado = true
        const data = clone(this.form)
        data.onesignalid = await get('onesignalid')
        authService.login(data)
          .then(() => {
            bus.$emit('hide-loader')
            this.botaoClicado = false
            this.$router.push({name: 'dashboard'})
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.botaoClicado = false
          })
      }
    }
  }
</script>

<template>
    <div class="login-box" v-bind:class="{'-day': turno === 'manha', '-night': turno === 'noite'}">

        <div class="overlay"></div>

        <div class="login-content">
            <div v-if="!mostrarRecuperacaoSenha">
                <div class="login-header">
                    <h2 class="login-header-title">SOU</h2>
                    <figure class="logo">
                        <img src="https://urcamp.edu.br/site/img/logos/logo-branco.png" alt="">
                    </figure>
                </div>
                <form class="login-form" v-on:submit.prevent>
                    <v-alert :value="true"
                             v-if="false"
                             style="margin-bottom: 15px;color:rgba(0,0,0,1);font-weight: bold;"
                             type="warning">
                        Esse portal está em fase de testes, qualquer informação exibida aqui não se refere a informações
                        reais das pessoas envolvidas
                    </v-alert>
                    <div class="login-form-item">
                        <div class="icon">
                            <i class="fas fa-user"></i>
                        </div>
                        <input type="tel"
                               v-model="form.login"
                               ref="login"
                               @keyup.enter.native="onLogin"
                               placeholder="Matrícula">
                    </div>
                    <div class="login-form-item">
                        <div class="icon">
                            <i class="fas fa-lock"></i>
                        </div>
                        <input type="password"
                               v-model="form.password"
                               ref="password"
                               @keyup.enter.native="onLogin"
                               placeholder="Senha">
                    </div>
                    <button type="submit"
                            @click="onLogin"
                            :disabled="botaoClicado || $v.form.$invalid"
                            class="login-submit">
                        Entrar
                    </button>
                    <div class="login-forget-password">
                        <a href="#" @click="mostrarRecuperacaoSenha = true">
                            Primeiro acesso/Esqueci minha senha
                        </a>
                    </div>
                </form>
            </div>
            <recuperar-senha :show.sync="mostrarRecuperacaoSenha"/>
        </div>
        <v-dialog v-model="mostrarModalInicial"
                  :width="isMobile().any() ? '90%' : '50%'">
            <v-card>
                <div class="mensagem-boas-vindas">
                    <h2 class="titulo-boas-vindas">Bem-vindo ao <strong>Sou URCAMP</strong></h2>
                    <h2 class="titulo-boas-vindas -subtitulo">Nosso portal foi repensando e reformulado</h2>
                    <v-container fluid grid-list-md>
                        <v-layout row wrap>
                            <v-flex sm6 xs12 class="bloco1">
                                <div class="icone"><i class="far fa-smile-beam"></i></div>
                                <div class="texto">
                                    Pensamos em você ao fazer esse novo portal
                                </div>
                            </v-flex>
                            <v-flex sm6 xs12 class="bloco2">
                                <div class="icone"><i class="fas fa-sitemap"></i></div>
                                <div class="texto">
                                    A nova estrutura facilita o acesso às suas informações mais importantes
                                </div>
                            </v-flex>
                            <v-flex sm6 xs12 class="bloco3">
                                <div class="icone"><i class="fas fa-user-graduate"></i></div>
                                <div class="texto">
                                    Seus horários, notas e frequência estão aqui também
                                </div>
                            </v-flex>
                            <v-flex sm6 xs12 class="bloco4">
                                <div class="icone"><i class="far fa-thumbs-up"></i></div>
                                <div class="texto">
                                    Sua opinião é importante para nós. Sinta-se livre para entrar em contato conosco
                                    e melhorarmos cada vez mais o nosso portal
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="info" flat @click="mostrarModalInicial = false; mostrarModalContato = true">Fale
                        Conosco
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostrarModalInicial = false">Acessar o portal</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <formulario-contato :mostrar.sync="mostrarModalContato"/>
    </div>
</template>

<style lang="scss">
    .mensagem-boas-vindas {
        padding: 20px;
        .titulo-boas-vindas {
            font-weight: 300;
            text-align: center;
            font-size: 30px;
            color: #797979;
            letter-spacing: -1px;
            strong {
                color: #333333;
            }
            &.-subtitulo {
                color: #9f9f9f;
                font-size: 20px;
                letter-spacing: normal;
            }
        }
        .layout {
            .flex {
                &:nth-child(1),
                &:nth-child(2) {
                    border-bottom: 1px solid #DDD;
                }
                .icone {
                    padding-top: 15px;
                    text-align: center;
                    font-size: 80px;
                    color: #474747;
                }
                .texto {
                    padding-bottom: 15px;
                    font-weight: 300;
                    text-align: center;
                    font-size: 18px;
                    line-height: 28px;
                    color: #5f5f5f;
                }
                &.bloco1 {
                    .icone {
                        color: #F19A40;
                    }
                }
                &.bloco2 {
                    .icone {
                        color: #1c742a;
                    }
                }
                &.bloco3 {
                    .icone {
                        color: #5e3571;
                    }
                }
            }
        }
    }

    .login-box {
        flex: 1;
        align-self: center;
        background-image: url('/static/img/bg-login-night.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;

        &.-day {
            background-image: url('/static/img/bg-login-day.jpg');
            .overlay {
                -webkit-animation: BgAnimationDayFrame 26s ease infinite;
                animation: BgAnimationDayFrame 26s ease infinite;
            }
        }
        &.-night {
            background-image: url('/static/img/bg-login-night.jpg');
            .overlay {
                -webkit-animation: BgAnimationNightFrame 26s ease infinite;
                animation: BgAnimationNightFrame 26s ease infinite;
            }
        }

        .overlay {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 2;
        }

        .login-content {
            min-height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            z-index: 5;
        }

        .login-header {
            display: block;
            width: 240px;
            height: 150px;
            margin: 0 auto;

            > .login-header-title {
                font-weight: 200;
                text-align: center;
                margin: 0;
                text-transform: uppercase;
                color: #FFF;
                letter-spacing: -1px;
                font-size: 28px;
                padding: 0;
                position: relative;
                bottom: -20px;
            }

            .logo {
                margin: 0;
                img {
                    margin: 0 auto;
                    display: block;
                    width: 300px;
                    max-width: 100%;
                }
            }
        }

        .login-form {
            width: 400px;
            margin: 0 auto;

            .login-form-item {
                margin-bottom: 10px;
                position: relative;
                height: 50px;

                .icon {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 50px;
                    height: 50px;
                    line-height: 50px;
                    text-align: center;
                    color: #FFF;
                }

                &:before {
                    content: "";
                    position: absolute;
                    left: 50px;
                    top: 4px;
                    width: 1px;
                    height: 42px;
                    background-color: rgba(255, 255, 255, .2);
                }

                input {
                    width: 100%;
                    line-height: 1;
                    height: 50px;
                    background: transparent;
                    border: 1px solid rgba(255, 255, 255, .25);
                    box-shadow: 0px 0px 6px rgba(0, 0, 0, .3);
                    color: #FFF;
                    padding-left: 64px;
                    font-size: 18px;

                    &:focus {
                        outline: none;
                        border: 1px solid rgba(255, 255, 255, .6);
                    }
                }
                input::placeholder {
                    color: rgba(255, 255, 255, .6);
                }
                input::-webkit-input-placeholder {
                    color: rgba(255, 255, 255, .6);
                }
                input::-moz-placeholder {
                    color: rgba(255, 255, 255, .6);
                }
                input:-ms-input-placeholder {
                    color: rgba(255, 255, 255, .6);
                }
                input:-moz-placeholder {
                    color: rgba(255, 255, 255, .6);
                }
            }
            .login-submit {
                display: block;
                text-align: center;
                line-height: 50px;
                width: 100%;
                background-color: #33443D;
                color: #FFF;
                font-weight: 700;
                text-transform: uppercase;
                font-size: 13px;
                border: 0;
                box-shadow: 0px 0px 6px rgba(0, 0, 0, .3);
                transition: all .4s ease-in-out;
                cursor: pointer;

                &:hover,
                &:active,
                &:focus {
                    background-color: #8F9E50;
                }

                &[disabled] {
                    color: #7e7e7e;
                    cursor: not-allowed !important;
                    background-color: #3f3f3f;
                }
            }
            .login-forget-password {
                text-align: center;
                padding: 15px 0;
                a {
                    color: #c2c2c2;
                    text-decoration: none;
                    text-transform: uppercase;
                    font-size: 12px;
                    text-shadow: 0px 0px 4px rgba(0, 0, 0, .3);
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    @-webkit-keyframes BgAnimationDayFrame {
        0% {
            background-color: rgba(0, 0, 0, 0.75);
        }
        25% {
            background-color: rgba(0, 0, 0, 0.4);
        }
        50% {
            background-color: rgba(0, 0, 0, 0.75);
        }
        75% {
            background-color: rgba(0, 0, 0, 0.4);
        }
        100% {
            background-color: rgba(0, 0, 0, 0.75);
        }
    }

    @keyframes BgAnimationDayFrame {
        0% {
            background-color: rgba(0, 0, 0, 0.75);
        }
        25% {
            background-color: rgba(0, 0, 0, 0.4);
        }
        50% {
            background-color: rgba(0, 0, 0, 0.75);
        }
        75% {
            background-color: rgba(0, 0, 0, 0.4);
        }
        100% {
            background-color: rgba(0, 0, 0, 0.75);
        }
    }

    @-webkit-keyframes BgAnimationNightFrame {
        0% {
            background-color: rgba(0, 0, 0, 0.6);
        }
        25% {
            background-color: rgba(0, 0, 0, 0.2);
        }
        50% {
            background-color: rgba(0, 0, 0, 0.6);
        }
        75% {
            background-color: rgba(0, 0, 0, 0.2);
        }
        100% {
            background-color: rgba(0, 0, 0, 0.6);
        }
    }

    @keyframes BgAnimationNightFrame {
        0% {
            background-color: rgba(0, 0, 0, 0.6);
        }
        25% {
            background-color: rgba(0, 0, 0, 0.2);
        }
        50% {
            background-color: rgba(0, 0, 0, 0.6);
        }
        75% {
            background-color: rgba(0, 0, 0, 0.2);
        }
        100% {
            background-color: rgba(0, 0, 0, 0.6);
        }
    }

    @media all and (max-width: 768px) {
        .mensagem-boas-vindas {
            padding: 10px;
            .titulo-boas-vindas {
                font-size: 20px;
                &.-subtitulo {
                    font-size: 17px;
                    line-height: 22px;
                }
            }
            .layout {
                .flex {
                    border-bottom: 1px solid #DDD;
                    &:last-child {
                        border: none;
                    }
                    .icone {
                        font-size: 50px;
                        padding-top: 10px;
                    }
                    .texto {
                        padding-bottom: 10px;
                        font-size: 14px;
                        line-height: 18px;
                    }
                }
            }
        }
        .login-box {
            .login-header,
            .login-form {
                width: 100%;
            }
            .login-header .logo img {
                width: 200px;
            }
            .login-content {
                > div {
                    padding: 0 20px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Login.vue?57ed1f9e